import stepTypes from '../../../modules/Steps/types';
import { updateSalesforceWaitlistStatus } from './updateSalesforceWaitlistStatus';

export function addMeToWaitlist(
  shouldPersonalDataCollected,
  goToStepType,
  selectedLocation,
  successfulLink,
  failureLink,
) {
  if (shouldPersonalDataCollected) goToStepType(stepTypes.waitlist);
  else updateSalesforceWaitlistStatus(selectedLocation, successfulLink, failureLink);
}
